<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">

    <h2 class="subtitle text-uppercase">Dados veículo</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">Placa </span><span>{{consulta?.placa || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Ano
        </span><span>{{consulta?.ano || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Modelo
        </span><span>{{consulta?.modelo || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <h2 class="subtitle text-uppercase">Precificação</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">Preço Fipe </span><span>R$ {{consulta?.precoFipe || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Código Fipe
      </span><span>{{consulta?.codigoFipe || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Mês Referência
      </span><span>{{consulta?.mesReferenciaFipe || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Ano Referência
        </span><span>{{consulta?.anoReferenciaFipe || 'NÃO INFORMADO'}}</span></li>


    </ul>

    <h2 class="subtitle text-uppercase">Preço Últimos 12 Meses </h2>
    <ul class="card-list-striped">

    </ul>

  </ng-container>
  <canvas #meuCanvas id="meuCanvas"></canvas>
</app-card-consulta>
